import React from 'react'
import { Grid } from '@mui/material'

import s from './styles.module.scss'

export default function SplitLayout({ left, right }) {
  return (
    <Grid container>
      <Grid item xs={12} sm={6} md={7}>
        {' '}
        {left}
      </Grid>
      <Grid item xs={12} sm={6} md={5} className={s.rightContainer}>
        {' '}
        {right}
      </Grid>
    </Grid>
  )
}
